import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Login, Home, Users, Vehicles, Devices, Reports, Maps, Settings, ForgotPassword, ResetPassword, VehiclesDetails, Organization, PeopleCounter, TeltonikaInstruction, Validator, panel, MobilityMonitorPrivacyPolicy, PrivacyPolicy, Parking, CameraMapings, CameraMappingsView, ParkingQRView, ParkingAvailability, ManageParkingLots, ParkingSlots, Gtfs, GtfsDetails, RouteForecast, RouteHistory } from '../Screens'
import { LedScreen, MenuLayout } from '../Components'
import allPaths from './paths'
import { Result, Button, ConfigProvider } from 'antd'
import itIT from 'antd/lib/locale/it_IT'
import enUS from 'antd/lib/locale/en_US'
import { useDispatch, useSelector } from 'react-redux'
import { setLanguage } from '../Redux/actions/languageAction'
import VideoPage from '../Screens/VideoPage/VideoPage'
import moment from 'moment'
import 'moment/locale/it'

const Page404 = (props) => {
    const { history } = props
    return (
        <Result
            status='404'
            title={<span style={{ color: 'black' }}>404</span>}
            subTitle={<span style={{ color: 'black' }}>Sorry, the page you visited does not exist </span>}
            extra={<Button
                className='add-button'
                onClick={() => history.push(allPaths?.HOME)}
            >Back Home</Button>}
        />
    )
}

const Routes = () => {
    const dispatch = useDispatch()
    const user = useSelector(state => state?.authReducer?.user)
    const language = useSelector(state => state.languageReducer.language)
    useEffect(() => {
        if (!language) {
            dispatch(setLanguage('it'))
        }
    }, [dispatch, language])

    useEffect(() => {
        if (language) {
            moment.locale(language)
        }
    }, [language])

    return (
        <ConfigProvider locale={language === 'it' ? itIT : enUS}>
            <Router>
                <Switch>
                <Route path={allPaths?.LOGIN} exact component={Login} />
                <Route path={`${allPaths?.PARKING_QR}/:qrToken`} exact component={ParkingQRView} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.LED_SCREEN} exact component={LedScreen} />
                <Route path={allPaths?.PARKING_AVAILABILITY} exact component={ParkingAvailability} />
                <Route path={allPaths?.ROUTE_FORECAST} exact component={RouteForecast} />
                <Route path={`${allPaths?.ROUTE_FORECAST}/:device`} exact component={RouteForecast} />
                <Route path={`${allPaths?.PARKING_SLOTS}/:organizationId`} exact component={ParkingSlots} />
                {/* <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.PANEL} exact component={panel} /> */}

                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.HOME} exact component={Home} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.VEHICLES} exact component={Vehicles} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.GTFS} exact component={Gtfs} />
                <MenuLayout setLanguage={setLanguage} language={language} path={`${allPaths?.GTFS_DETAILS}/:feedSource`} exact component={GtfsDetails} />
                <MenuLayout setLanguage={setLanguage} language={language} path={`${allPaths?.VEHICLESDETAILS}/:vehicleId`} exact component={VehiclesDetails} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.DEVICES} exact component={Devices} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.REPORTS} exact component={Reports} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.ROUTE_HISTORY} exact component={RouteHistory} />
                {/* <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.USERS} exact component={Users} /> */}
                <Route
                    path={allPaths?.USERS}
                    exact
                    render={(props) => {
                        return user?.role === 'user' ? <Page404 {...props} /> : (
                            <MenuLayout setLanguage={setLanguage} language={language} {...props} component={Users} />)
                    }} />

                {user?.role === 'superAdmin' ? <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.ORGANIZATION} exact component={Organization} /> : null}
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.USERS} exact component={Users} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.MAP} exact component={Maps} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.VALIDATOR} exact component={Validator} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.SETTINGS} exact component={Settings} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.PEOPLE_COUNTER} exact component={PeopleCounter} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.PARKING} exact component={Parking} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.CAMERA_MAPPING} exact component={CameraMapings} />
                <MenuLayout setLanguage={setLanguage} language={language} path={allPaths?.MANAGE_PARKING_LOTS} exact component={ManageParkingLots} />
                <Route path={allPaths?.FORGOT_PASSWORD} exact component={ForgotPassword} />
                {/* <Route setLanguage={setLanguage} language={language} path={allPaths?.TELTONIKA_INSTRUCTION} exact component={TeltonikaInstruction} /> */}
                <Route
                    path={allPaths?.TELTONIKA_INSTRUCTION}
                    exact
                    render={(props) => (
                        <TeltonikaInstruction {...props} language={language} />
                    )}
                />

                <Route path={`${allPaths?.RESET_PASSWORD}/:token`} exact component={ResetPassword} />
                <Route path={allPaths?.PRIVACY_POLICY} exact component={PrivacyPolicy} />
                <Route path={allPaths?.MOBILITY_PRIVACY_POLICY} exact component={MobilityMonitorPrivacyPolicy} />
                <Route path={allPaths?.VIDEO_STREAMING} exact component={VideoPage} />

                <Route path='/:page404' exact component={Page404} />

            </Switch >
            </Router>
        </ConfigProvider>
    )
}

export {
    Routes,
    Page404
}